import { render, staticRenderFns } from "./contactoComponent.vue?vue&type=template&id=7183fca7&scoped=true&"
import script from "./contactoComponent.vue?vue&type=script&lang=js&"
export * from "./contactoComponent.vue?vue&type=script&lang=js&"
import style0 from "./contactoComponent.vue?vue&type=style&index=0&id=7183fca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7183fca7",
  null
  
)

export default component.exports